import React, { useEffect, useRef } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const Editor = ({ onChange, editorLoaded, name, value, storyEditor = false }) => {
  
    useEffect(() => {
    }, []);
  
    return (
      <div>
        {editorLoaded ? (
          <CKEditor
            type=""
            name={name}
            editor={ClassicEditor}
            config={{
              ...(storyEditor && {
                toolbar: {
                  removeItems: [
                    "uploadImage", "mediaEmbed", "blockQuote", "insertTable",
                    "bulletedList", "numberedList", "outdent", "indent"
                  ]
                }
              }),
              ckfinder: {
                uploadUrl: "" //Enter your upload url
              }
            }}
            data={value}
            onChange={(event, editor) => {
              const data = editor.getData();
              onChange(data);
            }}
            
          />
        ) : (
          <div>Editor loading</div>
        )}
      </div>
    );
  }

  export default Editor;
